import { useMediaQuery } from 'usehooks-ts';

export function usePrefersReducedMotion() {
  return useMediaQuery('(prefers-reduced-motion: reduce)');
}
